import initTabs from "../components/initTabs.js";
import initRouteMaps from "../components/initRouteMaps.js";

document.addEventListener("DOMContentLoaded", () => {

    // console.log("event.js");

    initTabs();
    initRouteMaps();

});
